import { Component, EventEmitter, HostListener, OnDestroy, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-qrcode-reader',
  templateUrl: './qrcode-reader.component.html',
  styleUrls: ['./qrcode-reader.component.css']
})
export class QrcodeReaderComponent implements OnInit,OnDestroy  {
  /** 全部CHAT GPT寫的 有問題去問他 */
  @Output() onQRCode = new EventEmitter<string>();
  barcodeInput: string = '';
  isManual = false;
  state: 'Waiting' | 'Processing' | 'Done' = 'Waiting';

  private buffer = '';
  private lastKeyTime = 0;
  private inputTimer: any;

  ngOnInit(): void {
    this.reset();
  }

  ngOnDestroy(): void {
    clearTimeout(this.inputTimer);
  }

  @HostListener('window:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const now = Date.now();
    const diff = now - this.lastKeyTime;
    this.lastKeyTime = now;

    if (this.state === 'Done') return;
    if (this.isManual) return;

    if (diff > 100) {
      // 超過一定時間視為新輸入
      this.buffer = '';
      this.state = 'Processing';
    }

    if (event.key === 'Enter') {
      if (this.buffer.length > 0) {
        this.state = 'Done';
        const result = this.buffer;
        this.onQRCode.emit(result);
        this.buffer = '';
      }
    } else if (event.key.length === 1) {
      if (this.state === 'Waiting') {
        this.state = 'Processing';
      }
      this.buffer += event.key;
    }

    // 自動逾時重設
    clearTimeout(this.inputTimer);
    this.inputTimer = setTimeout(() => {
      if (this.state !== 'Done') {
        this.state = 'Waiting';
        this.buffer = '';
      }
    }, 3000); // 3 秒沒動作就重設
  }

  public reset() {
    this.buffer = '';
    this.isManual = false;
    this.barcodeInput = '';
    this.state = 'Waiting';
    this.lastKeyTime = Date.now();
  }
  submitManualInput() {
    const trimmed = this.barcodeInput.trim();
    if (trimmed.length > 0) {
      this.state = 'Done';
      this.onQRCode.emit(trimmed);
      this.barcodeInput = '';
      this.isManual = false;
    }
  }
}
